import Hatchback from '@/public/images/ackodrive/hatchback.svg';
import Sedan from '@/public/images/ackodrive/sedan.svg';
import SUV from '@/public/images/ackodrive/suv.svg';
import Diesel from '@/public/images/ackodrive/diesel.svg';
import CNG from '@/public/images/ackodrive/cng.svg';
import Petrol from '@/public/images/ackodrive/petrol.svg';
import Electric from '@/public/images/ackodrive/electric.svg';

export const garageServices = [
    {
        serviceIcon: 'spare-parts.svg',
        serviceTitle: 'Genuine spare parts ',
    },
    {
        serviceIcon: 'pick-drop.svg',
        serviceTitle: 'Free car pick & drop',
    },
    {
        serviceIcon: 'warranty.svg',
        serviceTitle: 'Warranty on spare parts',
    },
    {
        serviceIcon: 'tracking.svg',
        serviceTitle: 'Real time tracking ',
    },
];

export const carMaintenanceTasks = [
    'Engine Oil Replacement',
    'Oil Filter Replacement',
    'Air Filter Replacement',
    'Spark Plug Checking',
    'Fuel Filter Checking',
    'AC Filter Cleaning',
    'Brake Shoes Servicing',
    'Wheel Balancing',
    'Wheel Alignment',
    'Tyre Rotation',
    'Throttle Body Cleaning',
    'Gear Oil Top Up',
    'Coolant Top Up',
    'Wiper Fluid Replacement',
    'Brake Fluid Top Up',
    'Battery Water Top Up',
    'Interior Vacuuming',
    'Car Wash*',
];

export const servicesData = [
    {
        name: 'Engine oil replacement',
        basic: true,
        advanced: true,
    },
    {
        name: 'Oil filter replacement',
        basic: true,
        advanced: true,
    },
    {
        name: 'Wheel balancing',
        basic: false,
        advanced: true,
    },
    {
        name: 'Wheel Alignment',
        basic: false,
        advanced: true,
    },
    {
        name: 'Interior Vacuuming',
        basic: true,
        advanced: true,
    },
    {
        name: 'Car wash*',
        basic: true,
        advanced: true,
    },
    {
        name: 'Air Filter Replacement',
        basic: true,
        advanced: true,
    },
    {
        name: 'Coolant Top Up',
        basic: true,
        advanced: true,
    },
    {
        name: 'Wiper fluid replacement',
        basic: true,
        advanced: true,
    },
    {
        name: 'Brake Fluid Top Up',
        basic: true,
        advanced: true,
    },
    {
        name: 'Battery Water Top Up',
        basic: true,
        advanced: true,
    },
    {
        name: 'Brake Shoes Servicing',
        basic: true,
        advanced: true,
    },
    {
        name: 'AC Filter Cleaning',
        basic: true,
        advanced: true,
    },
    {
        name: 'Spark Plug Checking',
        basic: true,
        advanced: true,
    },
    {
        name: 'Fuel Filter Checking',
        basic: true,
        advanced: true,
    },
    // {
    //     name: 'Fuel Filter Replacement',
    //     basic: false,
    //     advanced: true,
    // },
    {
        name: 'Tyre Rotation',
        basic: false,
        advanced: true,
    },
    {
        name: 'Gear Oil Top Up',
        basic: false,
        advanced: true,
    },
    {
        name: 'Throttle Body Cleaning',
        basic: false,
        advanced: true,
    },
];

export const servicesGarage = [
    {
        id: 'filter',
        caption: 'Engine oil replacement',
    },

    {
        id: 'oil',
        caption: 'Oil filter replacement',
    },

    {
        id: 'clean',
        caption: 'Interior vacuuming',
    },
];

export const ROUTEMAP = {
    HOME: '/ad-services',
    BASEPAGE: '/ad-services/ackodrive-garage',
    MMV: '/ad-services/mmv',
    ADDRESS_SELECTION: '/ad-services/address-selection',
    SLOT_SELECTION: '/ad-services/slot-selection',
    CONFIRMATION: '/ad-services/confirmation-page',
    GARAGE_COMING_SOON: '/coming-soon',
    GARAGE_APPOINTMENT_CONFIRMATION: '/ad-services/appointment-confirmation',
    GARAGE_PICK_DROP: '/ad-services/pickup-drop',
    GARAGE_PRICING_PLANS: '/ad-services/pricing-plans',
    GARAGE_SERVICE_PLANS: '/ad-services/service-plans',
    GARAGE_PERIODIC_SERVICE: '/ad-services/periodic-service',
    GARAGE_SPECIFIC_REPAIR: '/ad-services/specific-repair',
    GARAGE_DETAILS_CAPTURE: '/ad-services/details-capture',
    BLR_KUDLU: '/bangalore/kudlu-gate',
    BLR_THANI: '/bangalore/thanisandra',
    BLR_WHITEFIELD: '/bangalore/whitefield',
    BLR_BANNERGHATTA: '/bangalore/bannerghatta',
    BLR_HAFEEZ: '/hyderabad/hafeezpet',
    BLR_PATPARGANJ: '/new-delhi/patparganj',
    GARAGE_HELP_PAGE: '/ad-services/schedule-callback',
    GARAGE_REDIRECT: '/ad-services/ackodrive-garage',
    GARAGE_NOT_SURE_ISSUE: '/ad-services/unknown-issue',
    CANCEL_PAGE: '/ad-services/appointment-cancelled',
    SELF_DROP: '/ad-services/self-drop',
    GARAGE_QR_CAMPAIGN: '/qr-campaign',
    GARAGE_QR_CAMAPIGN_VERIFICATION: '/qr-campaign/verification',
    LOCATION_VEHICLE_CHECK: '/ad-services/location-vehicle-check',
    AMD_GOTA: '/ahmedabad/gota',
    GUR_SECTOR_37: '/gurgaon/sector-37',
    CAR_SPA: '/ad-services/car-spa',
    SPECIFIC_REPAIR: '/ad-services/specific-repair',
    DEL_BADARPUR: '/new-delhi/badarpur',
};

export const PATHS_WITH_GARAGEID = [
    //ROUTEMAP.GARAGE_SERVICE_PLANS,
    ROUTEMAP.GARAGE_PICK_DROP,
    ROUTEMAP.GARAGE_PRICING_PLANS,
    //ROUTEMAP.GARAGE_SPECIFIC_REPAIR,
    ROUTEMAP.GARAGE_PERIODIC_SERVICE,
    ROUTEMAP.GARAGE_DETAILS_CAPTURE,
    //ROUTEMAP.GARAGE_NOT_SURE_ISSUE,
    ROUTEMAP.ADDRESS_SELECTION,
    ROUTEMAP.SLOT_SELECTION,
];

export const PATHS_WITH_USER_DETAILS_LOADER = [
    ROUTEMAP.GARAGE_PICK_DROP,
    ROUTEMAP.SELF_DROP,
    ROUTEMAP.LOCATION_VEHICLE_CHECK,
];

export const PATHS_WITH_CAR_EDIT_ICON = [
    ROUTEMAP.GARAGE_PICK_DROP,
    ROUTEMAP.GARAGE_PERIODIC_SERVICE,
    ROUTEMAP.GARAGE_SERVICE_PLANS,
    ROUTEMAP.GARAGE_PRICING_PLANS,
    //ROUTEMAP.GARAGE_SPECIFIC_REPAIR,
    ROUTEMAP.GARAGE_NOT_SURE_ISSUE,
];

export const API_PATHS = {
    GET_PRICING: '/v1/garage/pricing/vehicle',
    GET_SLOTS: '/v1/garage/slots',
    GET_SLOTS_AVAILABILITY: '/v1/garage/slots/availability',
    GET_BOOKING: '/v1/garage/bookings',
    GET_VEHICLE_DETAILS: '/car-details/v1/',
    GET_SAVED_ASSETS: '/asset_service/api/assets/vehicle',
    CREATE_ASSET: '/asset_service/api/assets/create/vehicle',
    GET_POLICY_DETAILS: '/motororchestrator/api/v2/policy',
    CREATE_BOOKING: '/v1/garage/bookings',
    GET_APPOINTMENT: '/v1/appointment',
    CANCEL_APPOINTMENT: '/v1/appointment/',
    GET_APPPOINTMENT_PRICING: '/v1/garage/pricing/',
    GET_PACKAGE_PRICING: '/v1/garage/pricing/package',
    GET_SERVICE_PRICING: '/v1/garage/pricing/service',
    GET_CAR_SERVICEABLE: '/v1/garage/serviceable',
    GET_PINCODE_MAPPING: '/v1/garage/pincode',
    GET_PINCODE_FROM_USERID: '/v1/garage/users/pincode',
    GET_GARAGE_DETAILS: '/v1/garage',
    GET_GARAGE_DETAILS_FROM_CITY: '/v1/garage/city',
    CREATE_TYPEFORM_LINK: '/v1/garage/users/npsLink',
    GET_REWARD_DETAILS: '/v1/garage/rewards',
};

export const IS_SLOT_BOOKING_ENABLED = true;
export const garageCities = ['bengaluru', 'bangalore', 'hyderabad', 'delhi'];

export const fuelTypeEnum = [
    {
        name: 'Petrol',
        id: 'PETROL',
        score: '',
    },
    {
        name: 'Diesel',
        id: 'DIESEL',
        score: '',
    },
    {
        name: 'CNG',
        id: 'CNG',
        score: '',
    },
    {
        name: 'LPG',
        id: 'LPG',
        score: '',
    },
    {
        name: 'EV',
        id: 'EV',
        score: '',
    },
];
export const cityList = [
    {
        cityName: 'Bangalore',
    },
    {
        cityName: 'Hyderabad',
    },
    {
        cityName: 'Delhi',
    },
    {
        cityName: 'Ahmedabad',
    },
    {
        cityName: 'Pune',
    },
    {
        cityName: 'Chennai',
    },
    {
        cityName: 'Other City',
    },
];

//Sr-Specific Repair
export enum RedirectFrom {
    SPECIFIC_REPAIR = 'specific-repair',
    PRICING_PLAN = 'pricing-plan',
    SR_PRICECHECK = 'sr-pricecheck',
    PRICECHECK_CTA = 'pricecheckcta',
    SR_PRICECHECK_CTA = 'sr-pricecheck-cta',
    V1_FLOW = 'v1_flow',
    V2_FLOW = 'v2_flow',
    PERIODIC_SERVICE = 'periodic',
    NA = 'NA',
    NOT_SURE_ABOUT_THE_ISSUE = 'not-sure-about-issue',
    GET_CAR_TO_GARAGE = 'car-garage',
    CAR_SPA_AND_CLEANING = 'car-spa',
    WHEEL_ALIGNMENT = 'wheel-alignment',
}
type ObjectType = {
    [key: string]: string;
};

export const GARAGE_URL_MAPPING: ObjectType = {
    acblrkud: ROUTEMAP.BLR_KUDLU,
    acblrtha: ROUTEMAP.BLR_THANI,
    achydhaf: ROUTEMAP.BLR_HAFEEZ,
    acko: ROUTEMAP.BLR_KUDLU,
    thanisandra: ROUTEMAP.BLR_THANI,
    acamdgha: ROUTEMAP.AMD_GOTA,
    acgurkha: ROUTEMAP.GUR_SECTOR_37,
    acdelbad: ROUTEMAP.DEL_BADARPUR,
    acblrgot: ROUTEMAP.BLR_BANNERGHATTA,
    acblrmah: ROUTEMAP.BLR_WHITEFIELD,
};

export const CITY_URL_MAPPING: ObjectType = {
    BANGALORE: 'abc',
    BENGALURU: 'xyz',
};

export const GARAGE_ID_MAP: Record<string, string> = {
    acblrkud: 'kudlu-gate',
    acblrtha: 'thanisandra',
    achydhaf: 'hafeezpet',
    acko: 'kudlu-gate',
    acamdgha: 'gota',
    acgurkha: 'sector-37',
    acdelbad: 'badarpur',
    acblrgot: 'bannerghatta',
    acblrmah: 'whitefield',
};

export const GARAGE_NAMES: Record<string, string> = {
    acblrkud: 'Kudlu Gate',
    acblrtha: 'Thanisandra',
    acko: 'Kudlu Gate',
    thanisandra: 'thanisandra',
    acamdgha: 'Gota',
    acgurkha: 'sector-37',
    acblrgot: 'Bannerghatta',
    acblrmah: 'Whitefield',
    acdelbad: 'Badarpur',
};

export const CarMakeImagesMap: { [key: string]: string } = {
    Tata: '/images/vehiclemake/tata-logo.png',
    Maruti: '/images/vehiclemake/suzuki-logo.png',
    Hyundai: '/images/vehiclemake/hyundai-logo.png',
    Mahindra: '/images/vehiclemake/mahindra-sport-utility-vehicle.png',
    Kia: '/images/vehiclemake/kia-logo.png',
    Toyota: '/images/vehiclemake/toyota-logo.png',
    Renault: '/images/vehiclemake/renault-logo.png',
    Honda: '/images/vehiclemake/honda-logo.png',
    Skoda: '/images/vehiclemake/skoda-logo.png',
    Nissan: '/images/vehiclemake/nissan-logo.png',
    Volkswagen: '/images/vehiclemake/volkswagen-logo.png',
    Jeep: '/images/vehiclemake/jeep-logo.png',
    MG: '/images/vehiclemake/mg-logo.png',
    Citroen: '/images/vehiclemake/Citroen.png',
    Ford: '/images/vehiclemake/Ford-Logo.png',
    Chevrolet: '/images/vehiclemake/Chevrolet.png',
    Datsun: '/images/vehiclemake/Datsun.png',
};

interface GarageEntry {
    urlName: string;
    displayName: string;
    routePath: string;
}

// Define the structure of the garage mapping
type GarageMapping = { [key: string]: GarageEntry };

// Development environment mapping
const DEV_GARAGE_MAPPING: GarageMapping = {
    // thanisandra: {
    //     urlName: 'thanisandra',
    //     displayName: 'Thanisandra',
    //     routePath: `${ROUTEMAP.BLR_THANI}`,
    // },
    acko: {
        urlName: 'kudlu-gate',
        displayName: 'Kudlu Gate',
        routePath: `${ROUTEMAP.BLR_KUDLU}`,
    },
    ackotest: {
        urlName: 'kudlu-gate',
        displayName: 'Kormangla',
        routePath: `${ROUTEMAP.BLR_KUDLU}`,
    },
    achydhaf: {
        urlName: 'hafeezpet',
        displayName: 'Hafeezpet',
        routePath: `${ROUTEMAP.BLR_HAFEEZ}`,
    },
    acblrkud: {
        urlName: 'kudlu-gate',
        displayName: 'Kudlu Gate',
        routePath: `${ROUTEMAP.BLR_KUDLU}`,
    },
    acblrtha: {
        urlName: 'thanisandra',
        displayName: 'Thanisandra',
        routePath: `${ROUTEMAP.BLR_THANI}`,
    },
    acdelpat: {
        urlName: 'patparganj',
        displayName: 'Patparganj',
        routePath: `${ROUTEMAP.BLR_PATPARGANJ}`,
    },
    acamdgha: {
        urlName: 'gota',
        displayName: 'Gota',
        routePath: `${ROUTEMAP.AMD_GOTA}`,
    },
    acgurkha: {
        urlName: 'sector-37',
        displayName: 'Sector 37',
        routePath: `${ROUTEMAP.GUR_SECTOR_37}`,
    },
    acdelbad: {
        urlName: 'badarpur',
        displayName: 'Badarpur',
        routePath: `${ROUTEMAP.DEL_BADARPUR}`,
    },
    acblrgot: {
        urlName: 'bannerghatta',
        displayName: 'Bannerghatta',
        routePath: `${ROUTEMAP.BLR_BANNERGHATTA}`,
    },
    acblrmah: {
        urlName: 'whitefield',
        displayName: 'Whitefield',
        routePath: `${ROUTEMAP.BLR_WHITEFIELD}`,
    },
};

// Production environment mapping
const PROD_GARAGE_MAPPING: GarageMapping = {
    acblrkud: {
        urlName: 'kudlu-gate',
        displayName: 'Kudlu Gate',
        routePath: `${ROUTEMAP.BLR_KUDLU}`,
    },
    acblrtha: {
        urlName: 'thanisandra',
        displayName: 'Thanisandra',
        routePath: `${ROUTEMAP.BLR_THANI}`,
    },
    achydhaf: {
        urlName: 'hafeezpet',
        displayName: 'Hafeezpet',
        routePath: `${ROUTEMAP.BLR_HAFEEZ}`,
    },
    // acko: {
    //     urlName: 'kudlu-gate',
    //     displayName: 'Kudlu Gate',
    //     routePath: `${ROUTEMAP.BLR_KUDLU}`,
    // },
    thanisandra: {
        urlName: 'thanisandra',
        displayName: 'Thanisandra',
        routePath: `${ROUTEMAP.BLR_THANI}`,
    },
    acdelpat: {
        urlName: 'patparganj',
        displayName: 'Patparganj',
        routePath: `${ROUTEMAP.BLR_PATPARGANJ}`,
    },
    acamdgha: {
        urlName: 'gota',
        displayName: 'Gota',
        routePath: `${ROUTEMAP.AMD_GOTA}`,
    },
    acgurkha: {
        urlName: 'sector-37',
        displayName: 'Sector 37',
        routePath: `${ROUTEMAP.GUR_SECTOR_37}`,
    },
    acdelbad: {
        urlName: 'badarpur',
        displayName: 'Badarpur',
        routePath: `${ROUTEMAP.DEL_BADARPUR}`,
    },
    acblrgot: {
        urlName: 'bannerghatta',
        displayName: 'Bannerghatta',
        routePath: `${ROUTEMAP.BLR_BANNERGHATTA}`,
    },
    acblrmah: {
        urlName: 'whitefield',
        displayName: 'Whitefield',
        routePath: `${ROUTEMAP.BLR_WHITEFIELD}`,
    },
};

export const GARAGE_MAPPING =
    process.env.ENVIRONMENT?.toLowerCase() === 'production'
        ? PROD_GARAGE_MAPPING
        : DEV_GARAGE_MAPPING;

const mapProdGarageId: Record<string, string> = {
    'kudlu-gate': 'acblrkud',
    thanisandra: 'acblrtha',
    hafeezpet: 'achydhaf',
    patparganj: 'acdelpat',
    gota: 'acamdgha',
    'sector-37': 'acgurkha',
    badarpur: 'acdelbad',
    bannerghatta: 'acblrgot',
    whitefield: 'acblrmah',
};

const mapDevGarageId: Record<string, string> = {
    'kudlu-gate': 'acko',
    thanisandra: 'acblrtha',
    hafeezpet: 'achydhaf',
    patparganj: 'acdelpat',
    gota: 'acamdgha',
    'sector-37': 'acgurkha',
    badarpur: 'acdelbad',
    bannerghatta: 'acblrgot',
    whitefield: 'acblrmah',
};

export const mapCityWithGarage: Record<string, string> = {
    bangalore: 'kudlu-gate',
    hyderabad: 'hafeezpet',
    'new-delhi': 'patparganj',
    ahmedabad: 'gota',
    gurgaon: 'sector-37',
};

const mapGarageId: Record<string, string> =
    process.env.NEXT_PUBLIC_ENV?.toLowerCase() === 'production'
        ? mapProdGarageId
        : mapDevGarageId;

export function getGarageId(location: string): string {
    return mapGarageId[location];
}

export const MY_PROFILE_PATH = '/my-profile/';
export const MY_QUOTES_PATH = '/my-quotes/';
export const MY_BOOKINGS_PATH = '/my-booking/';
export const CAR_VALUATION_PATH = '/used/car-valuation/';
export const FETCH_PROFILE = 'api/fetch-profile/';

export const ABOUT_ACKODRIVE_PATHS = {
    'About Us': '/about-us/',
    'Price Offer': '/best-price-offer/',
    'How It Works': '/how-it-works/',
    Reviews: '/reviews/',
    'Contact Us': '/contact-us/',
    Articles: '/articles/',
    News: '/news/',
};

export const FASTAG_PATH = '/fastag/';
export const CARS_PATH = '/cars/';

export const ITEM_TYPE = {
    ARTICLES: 'Interesting Articles',
    NEWS: 'Top stories and News',
    REVIEWS: 'Car & Bike reviews',
};

export const brandList = [
    {
        name: 'Tata',
        src: '/images/vehiclemake/tata-logo.png',
        url: `/collection/tata-cars/`,
    },
    {
        name: 'Maruti',
        src: '/images/vehiclemake/suzuki-logo.png',
        url: `/collection/maruti-suzuki-cars/`,
    },
    {
        name: 'Hyundai',
        src: '/images/vehiclemake/hyundai-logo.png',
        url: `/collection/hyundai-cars/`,
    },
    {
        name: 'Mahindra',
        src: '/images/vehiclemake/mahindra-sport-utility-vehicle.png',
        url: `/collection/mahindra-cars/`,
    },
    {
        name: 'Kia',
        src: '/images/vehiclemake/kia-logo.png',
        url: `/collection/kia-cars/`,
    },

    {
        name: 'Toyota',
        src: '/images/vehiclemake/toyota-logo.png',
        url: `/collection/toyota-cars/`,
    },
    {
        name: 'Renault',
        src: '/images/vehiclemake/renault-logo.png',
        url: `/collection/renault-cars/`,
    },
    {
        name: 'Honda',
        src: '/images/vehiclemake/honda-logo.png',
        url: `/collection/honda-cars/`,
    },
    {
        name: 'Skoda',
        src: '/images/vehiclemake/skoda-logo.png',
        url: `/collection/skoda-cars/`,
    },
    {
        name: 'MG',
        src: '/images/vehiclemake/mg-logo.png',
        url: `/collection/mg-cars/`,
    },
    {
        name: 'Nissan',
        src: '/images/vehiclemake/nissan-logo.png',
        url: `/collection/nissan-cars/`,
    },
    {
        name: 'Volkswagen',
        src: '/images/vehiclemake/volkswagen-logo.png',
        url: `/collection/volkswagen-cars/`,
    },
    {
        name: 'Jeep',
        src: '/images/vehiclemake/jeep-logo.png',
        url: `/collection/jeep-cars/`,
    },
    {
        name: 'Citroen',
        src: '/images/vehiclemake/Citroen.png',
        url: `/collection/citroen-cars/`,
    },
    {
        name: 'Land Rover',
        src: '/images/ackodrive/LandRover.png',
        url: `/collection/land-rover-cars/`,
    },
    {
        name: 'Jaguar',
        src: '/images/ackodrive/Jaguar.png',
        url: `/collection/jaguar-cars/`,
    },
    {
        name: 'Aston Martin',
        src: '/images/ackodrive/ASTONMARTIN.png',
        url: `/collection/aston-martin-cars/`,
    },
    {
        name: 'Bentley',
        src: '/images/ackodrive/BENTLEY.png',
        url: `/collection/bentley-cars/`,
    },
    {
        name: 'Mini',
        src: '/images/ackodrive/MINI.png',
        url: `/collection/mini-cars/`,
    },
    {
        name: 'BMW',
        src: '/images/ackodrive/BMW.png',
        url: `/collection/bmw-cars/`,
    },
    {
        name: 'Lotus',
        src: '/images/ackodrive/Lotus.png',
        url: `/collection/lotus-cars/`,
    },
    {
        name: 'Volvo',
        src: '/images/ackodrive/Volvo.png',
        url: `/collection/volvo-cars/`,
    },
    {
        name: 'Isuzu',
        src: '/images/ackodrive/ISUZU.png',
        url: `/collection/isuzu-cars/`,
    },
    {
        name: 'McLaren',
        src: '/images/ackodrive/McLaren.png',
        url: `/collection/mclaren-cars/`,
    },
    {
        name: 'Lexus',
        src: '/images/ackodrive/Lexus.png',
        url: `/collection/lexus-cars/`,
    },
    {
        name: 'Force',
        src: '/images/ackodrive/Force.png',
        url: `/collection/force-motors-cars/`,
    },
    {
        name: 'Audi',
        src: '/images/ackodrive/Audi.png',
        url: `/collection/audi-cars/`,
    },
    {
        name: 'RollsRoyce',
        src: '/images/ackodrive/RollsRoyce.png',
        url: `/collection/rolls-royce-cars/`,
    },
    {
        name: 'Maserati',
        src: '/images/ackodrive/Maserati.png',
        url: `/collection/maserati-cars/`,
    },
    {
        name: 'Porsche',
        src: '/images/ackodrive/Porsche.png',
        url: `/collection/porsche-cars/`,
    },
    {
        name: 'Lamborghini',
        src: '/images/ackodrive/Lamborghini.png',
        url: `/collection/lamborghini-cars/`,
    },
    {
        name: 'Ferrari',
        src: '/images/ackodrive/Ferrari.png',
        url: `/collection/ferrari-cars/`,
    },
];

export const bodyTypeCollectionsList = [
    {
        name: 'Hatchback',
        src: Hatchback,
        url: `/collection/hatchback-cars/`,
    },
    {
        name: 'Sedan',
        src: Sedan,
        url: `/collection/sedan-cars/`,
    },
    {
        name: 'SUV',
        src: SUV,
        url: `/collection/suv-cars/`,
    },
];

export const fuelTypeCollectionsList = [
    {
        name: 'Electric',
        src: Electric,
        url: `/collection/electric-cars/`,
    },
    {
        name: 'Petrol',
        src: Petrol,
        url: `/collection/petrol-cars/`,
    },
    {
        name: 'CNG',
        src: CNG,
        url: `/collection/cng-cars/`,
        extraPad: true,
    },
    {
        name: 'Diesel',
        src: Diesel,
        url: `/collection/diesel-cars/`,
    },
];
